import * as z from 'zod'

export const webhookActionSchema = z.object({
  type: z.literal('webhook'),
  url: z.string().describe('accepts variables'),
})

export type WebhookAction = z.infer<typeof webhookActionSchema>

export const notificationActionSchema = z.object({
  type: z.literal('notification'),
  userIds: z.array(z.string()),
})

export type NotificationAction = z.infer<typeof notificationActionSchema>

export const AUTOFILL_METADATA_SUGGESTION_COMMENT_KEY =
  '__suggestion_comment_id'

export const changeTypeSchema = z
  .enum(['direct', 'suggestion', 'auto-commit'])
  .default('direct')
  .optional()

export type ChangeType = z.infer<typeof changeTypeSchema>

export const aiAutofillActionSchema = z.object({
  type: z.literal('ai-autofill'),
  agentId: z.string().default('START'),
  blockId: z.string().nullable().describe('The id of the block to autofill'),
  prompt: z.string().describe('The instructions for the AI'),
  changeType: changeTypeSchema,
})

export type AiAutofillAction = z.infer<typeof aiAutofillActionSchema>

export const aiAutofillVariantActionSchema = z.object({
  type: z.literal('ai-autofill-variant'),
  agentId: z.string().default('START'),
  blockId: z
    .string()
    .nullable()
    .describe('The id of the variant set block to autofill'),
  prompt: z.string().describe('The instructions for the AI'),
  changeType: changeTypeSchema,
})

export type AiAutofillVariantAction = z.infer<
  typeof aiAutofillVariantActionSchema
>

/* -------------------------------------------------------------------------------------------------
 * All
 * -----------------------------------------------------------------------------------------------*/

export const workflowActionSchema = z.discriminatedUnion('type', [
  webhookActionSchema,
  notificationActionSchema,
  aiAutofillActionSchema,
  aiAutofillVariantActionSchema,
])

export type WorkflowAction = z.infer<typeof workflowActionSchema>
